import moment from 'moment'
import useSWRFetch from '../../helpers/hooks/useSWRFetch'
import { getRewardsNotifications, getRewardsNotificationSettings } from '../../helpers/api/rewards'
import { parseNotificationData } from './rewardsNotifications'

export const SETTINGS_KEY = 'rewards-notification-settings'

// HO-TASK-290: si el propietario silenció los avisos de Rewards. Mientras no
// se sepa (cargando o error) se trata como silenciado: es preferible no
// celebrar a celebrar algo que el propietario pidió no ver.
export const useRewardsNotificationSettings = (active = true) => {
  const { data, error, isLoading, mutate } = useSWRFetch(active ? SETTINGS_KEY : null, getRewardsNotificationSettings, {
    revalidateOnFocus: false
  })
  return {
    enabled: data?.data?.notifications_enabled === true,
    loaded: !!data,
    error,
    isLoading: active && isLoading,
    mutate
  }
}

// Notificaciones de un tipo `rewards-*` sin leer y recientes. Con
// `propertyId`, solo las de esa unidad (la cuenta puede tener varias).
export const useUnreadRewardsNotifications = (type, { active = true, limit = 10, maxAgeDays = 14, propertyId = null } = {}) => {
  const { data, mutate } = useSWRFetch(active ? ['rewards-notifications', type, limit] : null, (key, notificationType, size) =>
    getRewardsNotifications(notificationType, size)
  )
  const since = moment().subtract(maxAgeDays, 'days')
  const items = (data?.data || [])
    .filter((notification) => !notification.read_at && moment(notification.created_at).isAfter(since))
    .map((notification) => ({ ...notification, payload: parseNotificationData(notification) }))
    .filter((notification) => !propertyId || !notification.payload.property_id || Number(notification.payload.property_id) === Number(propertyId))
  return { items, mutate }
}
